module.exports = __webpack_public_path__ + "img/pic_6.cf0be9fc.png";